import React, {Component} from "react"
import PropTypes from "prop-types"

import qs from "qs"
import {hangPromise} from "../../promise"
import History from "../../history"
import SetAuthStatus from "./AuthedChecker/SetAuthStatus"
import CheckToken from "./AuthedChecker/CheckToken"
import stopAllAuthStreams from "../utils/auth/stopAllStreams"

export type SetAuthed = (options: {authed?: boolean; noauth?: boolean}) => void

interface AuthedCheckerContextData {
  setAuthed: SetAuthed
  load?: Promise<any> | null
  isAuthed: any
}

export const AuthedCheckerContext = React.createContext<AuthedCheckerContextData>({
  setAuthed: () => {},
  load: hangPromise(),
  isAuthed: null
})

export {SetAuthStatus, CheckToken}

export default class AuthedChecker extends Component {
  static contextTypes = {
    authed: PropTypes.object.isRequired,
    unauthed: PropTypes.object.isRequired
  }

  static defaultProps = {}

  state = {
    load: hangPromise()
  }

  authed = null

  isLoggedIn = () => {
    try {
      this.context.authed.get()
      return true
    } catch (e) {
      return false
    }
  }

  setAuthed: SetAuthed = ({authed, noauth}) => {
    if (noauth) {
      this.setState({load: Promise.resolve()})
    } else if (this.authed !== authed) {
      /** @desc: Not using state as we want this to be fully sync incase 2 nested-routes are mounted */
      this.authed = authed
      const load = this.runCheck(this.authed)
      this.setState({load})
    }
  }

  runCheck = (authed: boolean) => {
    if (authed) {
      return this.runAuthedCheck()
    } else {
      return this.runUnAuthedCheck()
    }
  }

  logout = () => {
    stopAllAuthStreams()
  }

  runAuthedCheck = async () => {
    if (!this.isLoggedIn()) {
      this.context.unauthed.start()
      return this.logout()
    } else {
      return this.context.authed.init().catch(this.logout)
    }
  }

  runUnAuthedCheck = async () => {
    if (this.isLoggedIn()) {
      const query = qs.parse(window.location.search.replace("?", ""))
      return History.replace({pathname: query.redirectTo ? query.redirectTo : "/"})
    } else {
      return this.context.unauthed.start()
    }
  }

  render() {
    const {children} = this.props
    const authState = {
      load: this.state.load,
      setAuthed: this.setAuthed,
      isAuthed: this.authed
    }

    return <AuthedCheckerContext.Provider value={authState}>{children}</AuthedCheckerContext.Provider>
  }
}
